export const LIMITS = {
  ITEM_MIN_PRICE: 15,
  MAX_TAGS_COUNT: 10,
  MAX_TAG_LEN: 32,
  MIN_TAG_LEN: 2,

  MAX_PACKAGE_WIDTH_IN_INCH: 200,
  MIN_PACKAGE_WIDTH_IN_INCH: 2,
  MAX_PACKAGE_LENGTH_IN_INCH: 200,
  MIN_PACKAGE_LENGTH_IN_INCH: 2,
  MAX_PACKAGE_HEIGHT_IN_INCH: 200,
  MIN_PACKAGE_HEIGHT_IN_INCH: 2,
  MAX_PACKAGE_WEIGHT_IN_LB: 200,
  MIN_PACKAGE_WEIGHT_IN_LB: 2,
} as const;
